;(function ($) {
	"use strict";
	window.AddressAutocomplete = function (options) {
		this._init(options);
	};

	$.extend(AddressAutocomplete.prototype, {
		$options: {
		    minLength: 3,
            checkInterval: 1000,
            lastCheckTime: 0,
            nextCheck: null,
            lastCheckedValue: "",
            searchedVal: "",
            maxTries: 0,
		},

		//=====================================================================
		//
		//=====================================================================

        initWhisperers: function() {
            var app = this;
            $('select[data-autocomplete-address]').each(function (i, el) {
                app.initStreetWhisperer($(el));
            });
        },
        
        initWhisperersBlock: function ($block) {
		    var app = this;
            $block.find('select[data-autocomplete-address-tpl]').each(function (i, el) {
                var $select = $(el);
                app.initStreetWhisperer($select);
                $select.data('autocompleteAddress', $select.data('autocompleteAddressTpl'));
            });
        },
                
        initStreetWhisperer($select) {
            var url = "https://nominatim.mpprostejov.cz/search?format=jsonv2",
                app = this;
            $select.select2({
                ajax: {
                    url: url,
                    dataType: 'json',
                    method: 'get',
                    delay: 500,
                    quietMillis: 1000,
                    timeout: 5000, //20s
                    data: function (params) {
                        return { q : params.term };
                    },
                    processResults: function (data) {
                        var items = [];
                        $.each(data, function (i, d) {
                            var id = d.osm_id;
                            switch (d.osm_type)
                            {
                                case "way":
                                    id = "W"+id;
                                    break;
                                case "node":
                                    id = "N"+id;
                                    break;
                                case "relation":
                                    id = "R"+id;
                                    break;
                            }
                            items.push({ id: id, text: d.display_name });
                        });

                        return {
                            results: items
                        };
                    },
                    transport: function (params, success, failure) {
                        var $request = $.ajax(params);

                        $request.then(success);

                        $request.fail(function (data, type) {
                            //TODO nacpat do selectu ze se nepovedlo pripojit
                            console.log('address fail: ', type);
                            var val = $('input.select2-search__field').val();
                            success([{ 'id' : val, 'text' : val }]);
                        });

                        return $request;
                    },
                },
                containerCssClass: "form-control",
                width: '100%',
                minimumInputLength: 2,
                tags: true,
                //createTag: false,
                language: "cs",
            }).on('select2:open', function (/*event*/) {
                var $select = $(this),
                    text = $select.find('option:selected').text(),
                    $search = $('input.select2-search__field');
                $search.val(text);
                window.setTimeout(function () {
                    $search.val(text).trigger('keyup').select();
                }, 200);

            }).on('select2:select', function () {
                var $select = $(this),
                    value = $select.val(),
                    address = $select.data('autocompleteAddress');
                app.getAddressData(value, address);
            });
        },

        initZipWhisperer: function ($select) {
		    
        },

        getAddressData: function (placeId, address) {
            var app = this,
                url = "https://nominatim.mpprostejov.cz/lookup?osm_ids="+placeId+"&format=json&addressdetails=1";

            $.ajax({
                url: url,
                dataType: 'json',
                method: 'get',
                success: function (response) {
                    app.$options.maxTries = 0;
                    if (response && (response.length > 0))
                    {
                        app.fillAddressData(response[0], address);
                    }
                    else
                    {
                        console.log("empty response", response);
                    }
                },
                error: function (e) {
                    if (app.$options.maxTries++ < 5) {
                        window.setTimeout(function () {
                            app.getAddressData(placeId, address);
                        }, 2000);
                    }
                    else
                    {
                        app.$options.maxTries = 0;
                    }
                    console.error(e);
                },
            });
        },

        fillAddressData: function(data, address)
        {
            var app = this,
                addrData = data.address,
                street = ("road" in addrData) ? addrData.road : "",
                houseNo = "",
                orientNo = "",
                town = ("city" in addrData) ? addrData.city :
                        (("town" in addrData) ? addrData.town :
                        (("village" in addrData) ? addrData.village : "")),
                zip = ("postcode" in addrData) ? addrData.postcode :
                        (("zip" in addrData) ? addrData.zip : ""),
                county = ("county" in addrData) ? addrData.county : "",
                country = ("country" in addrData) ? addrData.country_code.toUpperCase() : "",
                $desperadoController = window.$desperadoController;

            $desperadoController.lockAuthoritySelect(true);
            
            zip = zip.replace(/[^0-9]/g, "");
            if ("house_number" in addrData)
            {
                houseNo = addrData.house_number;
                if (houseNo.indexOf("/"))
                {
                    var parts = houseNo.split('/');
                    houseNo = parts[0];
                    orientNo = parts[1];
                }
            }
            if (county.indexOf("okres ") >= 0)
            {
                county = county.replace("okres ", "");
            }
            if (country.indexOf("cz") < 0)
            {
                //TODO vybrat defaultni spadovou obec
            }
            if (!street && ("village" in addrData))
            {
                if ("suburb" in addrData) {
                    street = addrData.suburb;
                }
                else {
                    street = addrData.village;
                }
            }
            if (!street && app.$options.searchedVal)
            {
                street = app.$options.searchedVal;
            }

            //console.log(addrData);
            var $select = $('select[name="'+address+'[street]"]');
            $select.find('option').remove();
            $select.append($('<option value="'+street+'" selected>'+street+'</option>')).trigger('change');
            $('input[name="'+address+'[house_number]"]').val(houseNo);
            $('input[name="'+address+'[orientation_number]"]').val(orientNo);
            //TOWN
            $select = $('select[name="'+address+'[town]"]');
            $select.find('option').remove();
            if (town) {
                $select.append($('<option value="'+town+'" selected>'+town+'</option>'));
            }
            $select.trigger('change');
            //ZIP
            $select = $('select[name="'+address+'[zip]"]');
            $select.find('option').remove();
            if (zip) {
                $select.append($('<option value="'+zip+'" selected>'+zip+'</option>'));
            }
            $select.trigger('change');
            //COUNTY
            $select = $('select[name="'+address+'[county]"]');
            $select.find('option').remove();
            if (county) {
                $select.append($('<option value="'+county+'" selected>'+county+'</option>'));
            }
            $select.trigger('change');
            //COUNTRY
            $select = $('select[name="'+address+'[country]"]');
            $select.find('option').remove();
            if (country) {
                $select.append($('<option value="'+country+'" selected>'+country+'</option>'));
            }
            $select.trigger('change');

            $desperadoController.lockAuthoritySelect(false);
            $desperadoController.findAuthority($select, null);
        },

        //=====================================================================

        showError: function (e) {
            console.log("Got error");
            var div = $("<div></div>");
            div.css({
                'position': "absolute"
                , 'top': "100px"
                , 'left': "20%"
                , 'width': "60%"
                , 'height': "600px"
                , 'background-color': "#FFF"
                , 'padding': "10px"
                , 'overflow-y': "scroll"
            });
            div.click(function(e) {
                e.preventDefault();
                return false;
            });
            div.html(e.responseText);
            var wrapper = $('<div></div>');
            wrapper.css({
                'position': "fixed"
                , 'top': "0"
                , 'left': "0"
                , 'width': "100%"
                , 'height': "100%"
                , 'background-color': "rgba(0, 0, 0, 0.3)"
            });
            wrapper.html(div);
            wrapper.click(function() {
                $(this).remove();
            });
            $('body').append(wrapper);
        },

        //=====================================================================
        
        initSearchListener: function () {
            var app = this;
		    $(document).on('keyup', 'input.select2-search__field', function () {
                app.$options.searchedVal = this.value;
            });
        },
        
        //=====================================================================

		_init: function (options) {
			this.$options = $.extend({}, this.$options, options || {});
			this.initWhisperers();
			this.initSearchListener();
		}
	});
    
	window.$addressAutocomplete = new AddressAutocomplete();
	
})(jQuery);
